import { makeAutoObservable } from 'mobx'
// Request
import FileDownload from 'js-file-download'
import { FileRequest } from '../requests/FileRequest'

class FileStore {
  documentAttachment = undefined

  constructor() {
    makeAutoObservable(this)
  }

  clearDocumentAttachment = () => {
    this.documentAttachment = undefined
  }

  /** File upload */
  uploadFile = formData => {
    return new Promise((resolve, reject) => {
      FileRequest.uploadFile(formData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** File upload trục */
  uploadFileTruc = formData => {
    return new Promise((resolve, reject) => {
      FileRequest.uploadFileTruc(formData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** File upload cloud */
  uploadFileCloud = formData => {
    return new Promise((resolve, reject) => {
      FileRequest.uploadCloudFile(formData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  downloadAttachment = file_id => {
    return new Promise((resolve, reject) => {
      FileRequest.downloadAttachment(file_id)
        .then(response => {
          this.documentAttachment = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  downloadFile = file_id => {
    return new Promise((resolve, reject) => {
      FileRequest.downloadAttachment(file_id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  downloadFileTruc = (file_id, file_name) => {
    return new Promise((resolve, reject) => {
      FileRequest.downloadFileTruc(file_id, file_name)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  renameFile = (file_id, file_name) => {
    return new Promise((resolve, reject) => {
      FileRequest.renameFile(file_id, file_name)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  renameFileTruc = (file_id, file_name) => {
    return new Promise((resolve, reject) => {
      FileRequest.renameFileTruc(file_id, file_name)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  downloadAttachmentTruc = file_id => {
    return new Promise((resolve, reject) => {
      FileRequest.downloadAttachmentTruc(file_id)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  uploadFileLTVB = formData => {
    return new Promise((resolve, reject) => {
      FileRequest.uploadFileLTVB(formData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  uploadExcel = formData => {
    return new Promise((resolve, reject) => {
      FileRequest.uploadExcel(formData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  getFileByEdocOutgoingId = (documentId, attachmentName) => {
    return new Promise((resolve, reject) => {
      FileRequest.getFileByEdocOutgoingId(documentId, attachmentName)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }
  getFileByEdocIncoingId = (documentId, attachmentName) => {
    return new Promise((resolve, reject) => {
      FileRequest.getFileByEdocIncomingId(documentId, attachmentName)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  getReceivedFileByEdocId = (documentId, attachmentName) => {
    return new Promise((resolve, reject) => {
      FileRequest.getReceivedFileByEdocId(documentId, attachmentName)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  getFileExcelById = fileId => {
    return new Promise((resolve, reject) => {
      FileRequest.getFileExcelById(fileId)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  getFileInternalEdocIncomingById = (documentId, attachmentName) => {
    return new Promise((resolve, reject) => {
      FileRequest.getFileInternalEdocIncomingById(documentId, attachmentName)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  getFileInternalEdocOutgoingById = (documentId, attachmentName) => {
    return new Promise((resolve, reject) => {
      FileRequest.getFileInternalEdocOutgoingById(documentId, attachmentName)
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }

  handleDownloadFile = async (id_file, name_file) => {
    try {
      const { data } = await this.downloadFile(id_file)
      const blob = new Blob([data], { type: 'application/pdf' })
      FileDownload(blob, name_file)
    } catch (err) {
      console.log(err)
    } finally {
    }
  }

  handleDownloadFileTruc = async (id_file, name_file) => {
    try {
      const { data } = await this.downloadFileTruc(id_file, name_file)
      const blob = new Blob([data], { type: 'application/pdf' })
      FileDownload(blob, name_file)
    } catch (err) {
      console.log(err)
    } finally {
    }
  }

  handleDownloadAttachmentTruc = async (id_file, name_file) => {
    try {
      const { data } = await this.downloadAttachmentTruc(id_file)
      const blob = new Blob([data], { type: 'application/pdf' })
      FileDownload(blob, name_file)
    } catch (err) {
      console.log(err)
    } finally {
    }
  }

  handleRenameFile = async (file_id, file_name) => {
    try {
      await this.renameFile(file_id, file_name)
    } catch (err) {
      console.log(err)
    } finally {
    }
  }

  deleteCloudObject = async objectId => {
    await FileRequest.deleteCloudObject(objectId)
  }
}
const fileStore = new FileStore()
export default fileStore
